<template>
  <div class="row">
    <div class="gr-12 gr-8@desktop gr-8@tablet-large gr-10@tablet upload-multiple">
      <div class="upload-multiple__button">
        <h2 class="medias-subtitle">
          {{ trans('media.images.label') }}
        </h2>
        <div
          class="upload-multiple__add-others-btn upload-btn"
          :class="{ 'upload-btn--loading': loading }"
        >
          <upload-multiple-media-image
            :disabled="loading"
            @loading="loading = true"
            @done="loading = false"
            @input="mediasUploaded"
          >
            <div class="upload-btn__slot upload-slot">
              <div
                v-if="loading"
                class="upload-slot__spinner"
              >
                <spinner :size="30" />
              </div>
              <a class="upload-slot__link">{{ trans('media.images.button') }}</a>
            </div>
          </upload-multiple-media-image>
        </div>
      </div>
      <div class="upload-multiple__list">
        <div
          ref="ordered-medias"
          class="ordered-medias"
        >
          <media
            v-for="(uuid, index) in uuids"
            :key="uuid"
            :index="index"
            :uuid="uuid"
            :validating="isValidating(uuid)"
            @updated="mediaUpdated"
            @deleted="mediaDeleted"
            @cover="mediaCover"
          />
        </div>
      </div>
      <upload-multiple-media-image
        droppable
        :disabled="loading"
        @loading="loading = true"
        @done="loading = false"
        @input="mediasUploaded"
      >
        <div class="upload-multiple__add multiple-add">
          <div
            class="multiple-add__slot add-slot"
            :class="{ 'add-slot--loading': loading }"
          >
            <div v-if="loading" class="add-slot__spinner">
              <spinner :size="40" />
            </div>
            <div role="button" class="btn btn--add btn--white">
              <span>
                {{ trans('media.images.button') }}
              </span>
            </div>
          </div>
        </div>
      </upload-multiple-media-image>
    </div>
    <input v-model="inputUuids" type="hidden" name="medias">
  </div>
</template>

<script>

import { Sortable, Swap } from 'sortablejs/modular/sortable.core.esm';
import Spinner from '@components/Spinner.vue';
import UploadMultipleMediaImage from '@components/UploadMultipleMediaImage.vue';
import { trans } from '@elements/translation';
import Media from './MediaList/Media.vue';

export default {
  components: { UploadMultipleMediaImage, Media, Spinner },
  props: {
    modelValue: { type: Array, default: () => [] },
    validatingUuids: { type: Array, default: () => [] },
  },
  emits: [ 'update:modelValue', 'cover', 'edited' ],
  data() {
    return {
      newUuid: null,
      loading: false,
      swapMode: false,
    };
  },
  computed: {
    uuids: {
      get() {
        return this.modelValue;
      },

      set(uuids) {
        this.$emit('update:modelValue', uuids);
      },
    },
    inputUuids() {
      return this.uuids.join(',');
    },
  },
  watch: {
    newUuid(uuid) {
      if (uuid === null) {
        return;
      }
      this.uuids = [ ...this.uuids, uuid ];
      this.newUuid = null;
    },
  },
  mounted() {
    Sortable.mount(new Swap());
    // eslint-disable-next-line no-new
    new Sortable(this.$refs['ordered-medias'], {
      swap: this.swapMode,
      onEnd: (event) => {
        this.swapUuids(event);
      },
    });
  },
  methods: {
    trans,
    mediasUploaded(uuids) {
      this.uuids = [ ...this.uuids, ...uuids ];
    },
    mediaUpdated(replaceIndex, replaceUuid) {
      const newUuids = [];
      this.uuids.forEach((uuid, index) => {
        if (index === replaceIndex) {
          newUuids.push(replaceUuid);
        } else {
          newUuids.push(uuid);
        }
      });
      this.uuids = newUuids;
    },
    mediaDeleted(deleteIndex) {
      const newUuids = [];
      this.uuids.forEach((uuid, index) => {
        if (index !== deleteIndex) {
          newUuids.push(uuid);
        }
      });
      this.uuids = newUuids;
    },
    mediaCover(coverIndex) {
      this.$emit('cover', coverIndex);
    },
    isValidating(uuid) {
      return this.validatingUuids.includes(uuid);
    },
    swapUuids(event) {
      if (this.swapMode) {
        const newUuids = [ ...this.uuids ];
        [ newUuids[event.oldIndex], newUuids[event.newIndex] ] = [ newUuids[event.newIndex], newUuids[event.oldIndex] ];
        this.uuids = newUuids;
        return;
      }

      const oldUuids = [ ...this.uuids ];
      const movedUuid = oldUuids.splice(event.oldIndex, 1);
      this.uuids = [
        ...oldUuids.slice(0, event.newIndex),
        ...movedUuid,
        ...oldUuids.slice(event.newIndex, oldUuids.length),
      ];
    },
  },
};

</script>
